import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

const Summary = ({summaryData,setShowSummary}) => {
   
  const handleBack=()=>{
    setShowSummary(false)
  }

  return (
    <div className="container mt-5">
      <div className="text-center">
        <div  className="card p-4 shadow-lg border-0">
          <h2
            className="fw-bold mb-3"
            style={{ fontSize: "24px", color: "#344567" }}
          >
            Thank you. Your order has been received.
          </h2>
          <h5 className="text-muted mb-4">Order Details</h5>
          <p className="mt-3" style={{color:'#000'}}>
            <strong>Reference Number:</strong>{" "}
            <span className="text-muted">
              {summaryData?.reference_number}
            </span>
            <br />
            <strong>Date:</strong>{" "}
            <span className="text-muted">
              {summaryData?.order_date}
            </span>
            <br />
            <strong>Total:</strong>{" "}
            <span className="text-muted">
              {summaryData?.total_amount}
            </span>
            <br />
            <strong>Payment Method:</strong>{" "}
            <span className="text-muted">
              {summaryData?.payment_method}
            </span>
          </p>

          <div className="oc-table mt-4">
            <div className="table-responsive">
              <table className="table table-bordered">
                <thead className="thead-light bg-light">
                  <tr>
                    <th className="text-left" style={{ color: "#344567" }}>
                      PRODUCT
                    </th>
                    <th className="text-center" style={{ color: "#344567" }}>
                      UNIT PRICE
                    </th>
                    <th className="text-center" style={{ color: "#344567" }}>
                      QTY
                    </th>
                    <th className="text-center" style={{ color: "#344567" }}>
                      SUBTOTAL
                    </th>
                    <th className="text-center" style={{ color: "#344567" }}>
                      DISCOUNT
                    </th>
                    <th className="text-center" style={{ color: "#344567" }}>
                      NET TOTAL
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {summaryData?.order_details.map((data, index) => (
                    <tr key={index}>
                      <td>{data?.product}</td>
                      <td className="text-center">${data?.unit_price}</td>
                      <td className="text-center">{data?.quantity}</td>
                      <td className="text-center">${data?.sub_total}</td>
                      <td className="text-center">${data?.discount}</td>
                      <td className="text-center">${data?.net_total}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="row mt-5">
            {/* Address Details */}
            <div className="col-lg-6">
              <div className="bg-light p-4 rounded shadow-sm">
                <h6
                  className="fw-bold mb-3"
                  style={{ color: "#344567", fontSize: "18px" }}
                >
                  Address Details
                </h6>
                <p className="mb-1">
                  {summaryData?.billing_address?.retailer_company_name}
                </p>
                <p>{summaryData?.billing_address?.address}</p>
                <p className="text-muted small mt-3" style={{fontSize:"12px"}}>
                  <span className="text-danger">*</span> If the address details
                  are incorrect, please contact Telsim Retailer Support to change
                  the delivery address before confirming the order.
                </p>
              </div>
            </div>

            {/* Summary Details */}
            <div className="col-lg-6 ">
              <div className="bg-light p-4 rounded shadow-sm text-end summary-details-purchase">
                <p style={{color:'#344567'}} className="mb-2">
                  <strong>Subtotal:</strong>{" "}
                  <span className="text-muted">
                    {summaryData?.subtotal}
                  </span>
                </p>
                <p style={{color:'#344567'}} className="mb-2">
                  <strong>Discount Applied:</strong>{" "}
                  <span className="text-muted">
                    {summaryData?.discount_applied}
                  </span>
                </p>
                <p style={{color:'#344567'}} className="mb-2">
                  <strong>Wallet Credit Used:</strong>{" "}
                  <span className="text-muted">
                    {summaryData?.wallet_used_amount}
                  </span>
                </p>
                <p style={{color:'#344567'}} className="mb-3">
                  <strong>Grand Total:</strong>{" "}
                  <span className="text-muted">
                    {summaryData?.grand_total}
                  </span>
                </p>

                {/* Total Section */}
                <div
                  className="d-flex justify-content-end align-items-center"
                  style={{
                    gap: "10px",
                    fontSize: "18px",
                    fontWeight: "bold",
                    color: "#344567",
                  }}
                >
                  {/* <span>Total:</span> */}
                  {/* <span
                    className="text-muted"
                    style={{
                      fontSize: "16px",
                      fontWeight: "normal",
                    }}
                  >
                    {summaryData?.total_amount}
                  </span> */}
                </div>
              </div>
            </div>
          </div>
      <button style={{margin:"10px", backgroundColor:"#e20e75",borderRadius:"5px" ,border:"none" ,color:"white",padding:"3px",fontSize:"19px",width:"134px"}}  onClick={handleBack} > Back</button>
        </div>
      </div>
    </div>
  );
};

export default Summary;
